import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import Advertise from '../pages/advertise/page';
import Login from '../pages/login/page';
import Register from '../pages/register/page';
import ForgotPassword from '../pages/forgot-password/page';
import Dashboard from '../pages/dashboard/page';
import AdminDashboard from '../pages/admin-dashboard/page';
import ListingDetail from '../pages/listing-detail/page';
import CryptoAI from '../pages/crypto-ai/page';
import PokTaToken from '../pages/poktatoken/page';
import Roadmap from '../pages/roadmap/page';
import AsistenteIA from '../pages/asistente-ia/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/nosotros',
    element: <About />,
  },
  {
    path: '/contacto',
    element: <Contact />,
  },
  {
    path: '/anuncio',
    element: <Advertise />,
  },
  {
    path: '/anuncio/:id',
    element: <ListingDetail />,
  },
  {
    path: '/crypto-ia',
    element: <CryptoAI />,
  },
  {
    path: '/poktatoken',
    element: <PokTaToken />,
  },
  {
    path: '/roadmap',
    element: <Roadmap />,
  },
  {
    path: '/asistente-ia',
    element: <AsistenteIA />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/registro',
    element: <Register />,
  },
  {
    path: '/recuperar-contrasena',
    element: <ForgotPassword />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/admin-dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;